import './thumb_badge.less';

import classnames                       from 'classnames';
import React                            from 'react';

import { ThumbsDown as ThumbsDownIcon } from 'react-feather';
import { ThumbsUp as ThumbsUpIcon }     from 'react-feather';


export default function ThumbBadge({ type }) {
  const className = classnames('thumb-badge', type);
  const isUp      = type === 'up';
  const isDown    = type === 'down';
  return (
    <div className={className}>
      {isUp && <ThumbsUpIcon/>}
      {isDown && <ThumbsDownIcon/>}
    </div>
  );
}
